import React from "react";
import { generateCRUDRoutes } from "../../../../utils/index";

import { DatabaseOutlined } from '@ant-design/icons';
import CattleAnimals from "./index";
import ViewCattle from "./view";
import EditCattle from "./edit";
import { MODULE_REG_CATTLE } from "variables/constants";

const cattleRoutes = [	
	generateCRUDRoutes({
		mainTitle: "Cattles",
		basePath: "registered-animals/cattles",
		mainComponent: <CattleAnimals />,
	    layout: "/console",
		icon: <DatabaseOutlined className="h-6 w-6" />,
	    subTitle:"Cattle",
	    viewComponent: <ViewCattle />,
	    createComponent: <EditCattle />,
	    editComponent: <EditCattle />,
		modduleId: MODULE_REG_CATTLE,
	})
]

export default cattleRoutes;